import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "How to build a CRM from scratch?",
    answer: `<p>Developing a CRM from the ground up requires a strategic plan. Start by identifying your CRM goals and needs, and then choose a suitable technology stack. Design an effective database schema and a user-friendly interface, followed by iterative development, thorough testing, and smooth deployment.</p>`,
  },
  {
    question: "Is custom software expensive?",
    answer: `<p>Although custom software development involves an initial investment, its long-term advantages often surpass the costs. Custom solutions are specifically designed to meet your business needs, enhancing efficiency and scalability.</p>`,
  },
  {
    question: "Can you build your own CRM software?",
    answer: ` <p>Creating your own CRM software is a complex task that demands expertise in software development, database design, and user interface design. While it is possible, it often requires significant time, resources, and technical skills. To achieve a successful result and avoid potential challenges, it is recommended to work with experienced custom CRM developers.</p>`,
  },
  {
    question: "What are custom CRM system development services?",
    answer: `<p>Custom CRM development services involve designing a Customer Relationship Management system tailored to the unique needs and requirements of a business. Unlike ready-made solutions, custom CRM development ensures the software aligns perfectly with your processes, enhancing efficiency and productivity.</p>`,
  },
  {
    question: "Can CRM replace ERP?",
    answer: `<p>While CRM (Customer Relationship Management) and ERP (Enterprise Resource Planning) systems share some features, they serve different purposes within an organization. CRM focuses on managing customer interactions and relationships, while ERP integrates various business processes such as finance, human resources, and supply chain management. Though they complement each other, CRM cannot replace ERP and vice versa. For a comprehensive business solution, integrating both CRM and ERP systems is often recommended.</p>`,
  },
  {
    question: "How much does it cost to build a custom CRM?",
    answer: `<p>The cost of developing a custom CRM varies based on factors such as project complexity, customization needs, technology stack, integration requirements, and ongoing maintenance. Basic custom CRMs for small to medium businesses may start at $50,000, while complex solutions for large enterprises can exceed $500,000.</p>`,
  },
  {
    question: "How long does it take to build CRM from scratch?",
    answer: `<p>To successfully create your own CRM, you need time, money, and a dedicated project team. How long does it take to build a CRM? The development process can take anywhere from three to ten months. Depending on the size of your company and the scope of the project, some CRMs may take up to 12 or 18 months to complete.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>CRM Developers FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
